import _ from 'lodash';
import moment from 'moment';
import { businessSchedule, businessScheduleParkMode, getTargetDateClosedSchedule } from '../component/restaurant/schedule-dialog.component';
import { BookingServiceSchedule, Schedule, SettingClosedSchedule } from '../models';

/**
 * 分析营业时间表和闭店时间表，返回新的营业时间表
 */
export function updateScheduleData(serviceSchedule, settingClosedSchedule, parkMode?: boolean) {
    try {
        let newScheduleData = _.cloneDeep(serviceSchedule);
        const todyIsoWeekday = moment(new Date()).isoWeekday();
        // 排序（今天放在第一位）
        newScheduleData = newScheduleData.sort((n, m) => {
            const position = (n.week - todyIsoWeekday) < 0 ? n.week + 7 : n.week;
            const nextPosition = (m.week - todyIsoWeekday) < 0 ? m.week + 7 : m.week;
            return position - nextPosition;
        })
        // 设置新的营业时间表数据
        newScheduleData = newScheduleData.map((n, index) => {
            // 周几
            const todyIsoWeekday = moment(new Date()).add(index, 'day').isoWeekday();
            if (n.week === todyIsoWeekday) {
                // 年月日
                const targetDate = moment(new Date()).add(index, 'day').format('YYYY-MM-DD')
                // 目标日期的营业时间段
                const dateTimeRanges: Schedule = _.find(newScheduleData, (item) => { return item.week === todyIsoWeekday }) || {};
                // 目标日期的营业时间段（是否是全体营业）
                const timeRanges = dateTimeRanges.time_24_hours ? [{
                    start_time: '00:00:00',
                    end_time: '23:59:00',
                    selftake_status: dateTimeRanges.selftake_status,
                    takeaway_status: dateTimeRanges.takeaway_status
                }] : (dateTimeRanges.time_ranges || [])
                // 目标日期，在休业时间内，则24小时开关为false
                const hasClose = _.find(settingClosedSchedule, (v) => {
                    return moment(targetDate, 'YYYY-MM-DD').isBetween(
                        moment(v.start_date, moment.HTML5_FMT.DATETIME_LOCAL_MS),
                        moment(v.end_date, moment.HTML5_FMT.DATETIME_LOCAL_MS),
                        'day',
                        '[]'
                    )
                })
                if (hasClose) {
                    _.set(n, 'time_24_hours', false)
                }
                // 最终显示的营业时间表（对应的周几）
                if (parkMode) {
                    const finalTimeRanges = businessScheduleParkMode(timeRanges, getTargetDateClosedSchedule(targetDate, settingClosedSchedule))
                    _.set(n, 'time_ranges', finalTimeRanges)
                } else {
                    const finalTimeRanges = businessSchedule(timeRanges, getTargetDateClosedSchedule(targetDate, settingClosedSchedule))
                    _.set(n, 'time_ranges', finalTimeRanges)
                }
            }
            return n;
        })
        // 数组恢复原来的位置（周一第一位）
        newScheduleData = newScheduleData.sort((n, m) => {
            return n.week - m.week;
        })
        return newScheduleData
    } catch (error) {
        console.log(error);
    }
}

function formateDate(date: string | undefined, format: string) {
    return date ? moment(date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format(format) : ''
}

/**
 * 获取预定时间结合休业时间
 */
export function parkModeGetTodyOpenTime(props: {
    bookingServiceSchedule: BookingServiceSchedule[],
    bookingNoServiceSchedule: SettingClosedSchedule[],
    date: string,
    // 忽略现在时间之前的时间段
    ignoreNowTime?: boolean
}) {
    const { bookingServiceSchedule, bookingNoServiceSchedule: disabledDates, date } = props;

    const selectDateFormat = moment(date).format('YYYY-MM-DD');
    const currentTime = moment().format('YYYY-MM-DD HH:mm');
    const week = moment(selectDateFormat).isoWeekday();
    // 这一天不可以预定的开始时间
    let closeStartTime = '';
    // 这一天不可以预定的结束时间
    let closeEndTime = '';
    // 闭店时间范围：开始结束不是同一天
    if (disabledDates) {
        const cloneDisabledDates = _.cloneDeep(disabledDates)
        const selectCloseDate = _.filter(cloneDisabledDates, (item) => {
            const start_date = item.start_date && formateDate(item.start_date, 'YYYY-MM-DD')
            const end_date = formateDate(item?.end_date, 'YYYY-MM-DD')
            return (moment(selectDateFormat).isBetween(start_date, end_date, 'date', '[]')
                && (start_date !== end_date));
        })
        if (selectCloseDate) {
            let newCloseStartTime = '';
            let newCloseEndTime = '';
            selectCloseDate.forEach((item) => {
                const newStartDate = moment(item.start_date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD')
                const newEndDate = moment(item.end_date, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD')

                if (moment(selectDateFormat).isSame(newStartDate)) {
                    if (newCloseStartTime) {
                        const start_time = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                        if (moment(newCloseStartTime).isAfter(start_time)) {
                            newCloseStartTime = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') || ''
                        }
                    } else {
                        newCloseStartTime = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') || ''
                    }
                }
                if (moment(selectDateFormat).isSame(newEndDate)) {
                    if (newCloseEndTime) {
                        const start_time = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                        if (moment(newCloseEndTime).isBefore(start_time)) {
                            newCloseEndTime = moment(item.end_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') || ''
                        }
                    } else {
                        newCloseEndTime = moment(item.end_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss') || ''
                    }
                }
            })
            closeStartTime = newCloseStartTime;
            closeEndTime = newCloseEndTime;
        }
    }
    // 闭店时间范围：开始结束都是同一天的
    let sameCloseDate: SettingClosedSchedule[] = []
    if (disabledDates) {
        const cloneDisabledDates = _.cloneDeep(disabledDates)
        sameCloseDate = _.filter(cloneDisabledDates, (item) => {
            const start_date = item.start_date && formateDate(item.start_date, 'YYYY-MM-DD')
            const end_date = formateDate(item?.end_date, 'YYYY-MM-DD')
            return (moment(selectDateFormat).isBetween(start_date, end_date, 'date', '[]')
                && (start_date === end_date));
        })
    }
    // 赋予预约详细时间段按钮 selectKey、disabled
    const cloneBookingServiceSchedule = _.cloneDeep(bookingServiceSchedule)
    // 找出选择的日期的所对应的周几
    const scheduleItem = _.find(cloneBookingServiceSchedule, (n) => { return n.week === week })

    // cloneBookingServiceSchedule = cloneBookingServiceSchedule.map((scheduleItem) => {


    let booking_time_interval = scheduleItem?.booking_time_interval || []
    if (booking_time_interval && booking_time_interval.length > 0) {
        booking_time_interval = booking_time_interval.map((n, nameIndex) => {
            if (n.time_interval_detail && n.time_interval_detail.length > 0) {
                n.time_interval_detail.map((v, timeIndex) => {
                    // 设置时间段按钮的key、disabled
                    _.set(v, 'selectKey', `${nameIndex}-${timeIndex}`)
                    _.set(v, 'disabled', false)
                    const start_time = moment(v.start_time, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    const end_time = moment(v.end_time, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    // 将闭店开始时间之后的时间段设置不可点击
                    if (closeStartTime && (moment(closeStartTime).isSameOrBefore(start_time))) {
                        _.set(v, 'disabled', true)
                    }
                    // 将闭店结束时间之前的时间段设置不可点击
                    if (closeEndTime && (moment(closeEndTime).isSameOrAfter(end_time))) {
                        _.set(v, 'disabled', true)
                    }
                    // 设置选择的日期的闭店时间段设置不可点击
                    if (sameCloseDate.length > 0) {
                        sameCloseDate.forEach((item) => {
                            const endTimeInterval = moment(item.start_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                            const startTimeInterval = moment(item.end_time_interval, 'HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                            if (
                                moment(start_time).isBetween(endTimeInterval, startTimeInterval,
                                    'minutes', '[]')
                                && moment(end_time).isBetween(endTimeInterval, startTimeInterval, 'minutes', '[]')
                            ) {
                                _.set(v, 'disabled', true)
                            }
                        })
                    }
                    // 开始时间在现在时间之前设置不可点击
                    if (moment(`${selectDateFormat} ${v.start_time}`).isBefore(currentTime) && props.ignoreNowTime) {
                        // 时间表需要显示  超过当前时间的时间
                        _.set(v, 'disabled', true);
                    }
                    return v
                })
            }
            return n
        })
    }
    const timeRanges = booking_time_interval.reduce<{
        start_time?: Date;
        end_time?: Date;
        disabled?: boolean;
    }[]>((pre, cur) => {
        if (cur.time_interval_detail) {
            const timeInterval = cur.time_interval_detail.filter(n => {
                return !n.disabled;
            })
            return [...pre, ...timeInterval];
        } else {
            return [...pre];
        }
    }, []);
    // 排序开始时间从小到大
    timeRanges.sort((a, b) => {
        return moment(a.start_time, 'HH:mm').isBefore(moment(b.start_time, 'HH:mm')) ? -1 : 1;
    })
    return timeRanges

}


/**
 * 获取游乐园当前可选时间第一位
 */
export function getParkSchedule(parkSchedule: string[], filterDisabled?: boolean) {
    // 缓存当前时间对象，避免重复创建
    const currentMoment = moment();

    // 使用 reduce 代替 map + filter，减少数组遍历次数
    const result = parkSchedule.reduce<Array<{ start_time: string; disabled: boolean }>>((acc, time) => {
        const isDisabled = moment(time, 'HH:mm').isBefore(currentMoment, 'minute');

        // 如果需要过滤且时间已过期，则跳过
        if (filterDisabled && isDisabled) {
            return acc;
        }

        acc.push({
            start_time: time,
            disabled: isDisabled
        });

        return acc;
    }, []);

    // 按时间从小到大排序
    return result.sort((a, b) =>
        moment(a.start_time, 'HH:mm').isBefore(moment(b.start_time, 'HH:mm')) ? -1 : 1
    );
}


export function filterFullBookedTime(serviceSchedule: Schedule[], fullBookedTime: string, isPickUp: boolean) {
    const weekday = moment(fullBookedTime, 'YYYY-MM-DD HH:mm').isoWeekday();

    let nextTime = '';
    let needToCheck = false;
    let nextDay = 0;
    const currentDate = moment(fullBookedTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD');
    const fn = (week: number) => {
        const scheduleItem = serviceSchedule[week - 1] || {};
        let ranges = scheduleItem?.time_ranges || [];
        // 24小时营业
        if (isPickUp ? (scheduleItem.selftake_status && scheduleItem.time_24_hours)
            : (scheduleItem.takeaway_status && scheduleItem.time_24_hours)) {
            ranges = [];
            nextTime = moment(currentDate).add(nextDay, 'days').format('YYYY-MM-DD 00:00');
            needToCheck = false;
        }
        // ranges 排序 按照开始时间从小到大
        ranges.sort((a, b) => {
            return moment(a.start_time, 'HH:mm').isBefore(moment(b.start_time, 'HH:mm')) ? -1 : 1;
        })
        if (nextDay != 0 && ranges.length > 0) {
            // 找到有效的时间范围
            const rangeItem = ranges.find((item) => isPickUp ? item.selftake_status : item.takeaway_status);
            if (rangeItem) {
                nextTime = moment(currentDate).add(nextDay, 'days').format('YYYY-MM-DD ') + rangeItem?.start_time || '00:00';
                needToCheck = isPickUp ? !!rangeItem?.selftake_orders_limit : !!rangeItem?.orders_limit;
            }
        } else {
            let findNextRange = false;

            ranges?.forEach((rangeItem, rangeIndex, rangeArray) => {
                const start_time = moment(rangeItem.start_time, 'HH:mm');
                const end_time = moment(rangeItem.end_time, 'HH:mm');
                const time = moment(fullBookedTime, 'YYYY-MM-DD HH:mm').format('HH:mm');
                if (findNextRange) {
                    if (isPickUp ? rangeItem?.selftake_status : rangeItem?.takeaway_status) {
                        nextTime = moment(currentDate).add(nextDay, 'days').format('YYYY-MM-DD ') + rangeItem?.start_time || '';
                        needToCheck = isPickUp ? !!rangeItem?.selftake_orders_limit : !!rangeItem?.orders_limit;
                    }
                } else {
                    // 是否在范围内 && 是否开启
                    if (moment(time, 'HH:mm').isBetween(start_time, end_time, 'minutes', '[]')
                        && (isPickUp ? rangeArray[rangeIndex]?.selftake_status : rangeArray[rangeIndex]?.takeaway_status)
                    ) {
                        // 自取+15分钟  外送+20分钟
                        const newTime = moment(time, 'HH:mm').add(isPickUp ? 15 : 20, 'minutes').format('HH:mm');

                        // 加之后，是否还在范围内，不在则找下个时间段
                        if (moment(newTime, 'HH:mm').isBetween(start_time, end_time, 'minutes', '[]')) {
                            nextTime = moment(currentDate).add(nextDay, 'days').format('YYYY-MM-DD ') + newTime;
                            needToCheck = isPickUp ? !!rangeItem?.selftake_orders_limit : !!rangeItem?.orders_limit;
                        } else {
                            if (rangeIndex !== rangeArray.length - 1) {
                                findNextRange = true;
                            }
                        }
                    }
                }
            })
        }

        if (nextDay > 15) {
            return
        }

        if (!nextTime) {
            const _week = week + 1 === 8 ? 1 : week + 1;
            nextDay += 1;
            fn(_week);
        }
    }
    fn(weekday);

    return { nextTime, needToCheck };
}